import React from 'react';

import { getBenchmarkName, benchmarkSorter } from '../../../helpers/nameHelpers';
import * as helpers from '../portfolioHelpers';


function getBenchmarkRow(benchmark, currencyType) {
    return <tr key={`cr1_${benchmark.name}`}>
        <td style={{ whiteSpace: 'nowrap' }}>{getBenchmarkName(benchmark.name, currencyType)}</td>
        <td>{helpers.formatCell(benchmark.portfolioTimeWeightedHoldingPeriodReturn)}</td>
        <td>{helpers.formatCell(benchmark.portfolioTimeWeightedHoldingPeriodReturn_BeforeFees)}</td>
        <td>{helpers.formatCell(benchmark.portfolioTimeWeightedHoldingPeriodReturn - benchmark.portfolioTimeWeightedHoldingPeriodReturn_BeforeFees)}</td>
        <td>{helpers.formatCell(benchmark.portfolioIRR)}</td>
        <td>{helpers.formatCell(benchmark.portfolioIRR_BeforeFees)}</td>
    </tr>
}

const Table = (props) => {

    const { portfolio } = props;
    const { reportData } = portfolio;

    const currencyType = portfolio.portfolio.data.currencyType;

    return <div>
        <table style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
            <thead>
                <tr>
                    <th>Comparative Return Table 2</th>
                    <th colSpan={3}>Time Weighted Holding Period Return (TWR), annualized %</th>
                    <th colSpan={2}>Dollar Weighted (Internal Rate of Return, IRR), annualized %</th>
                </tr>
                <tr>
                    <th>Client Portfolios</th>
                    <th>After Fees</th>
                    <th>Before Fees</th>
                    <th>Difference due to Fees</th>
                    <th>After Fees</th>
                    <th>Before Fees</th>
                </tr>
            </thead>
            <tbody>
                {getBenchmarkRow(reportData.portfolio, currencyType)}
                <tr>
                    <td colSpan={21} style={{ fontWeight: 'bold', paddingTop: 20 }}>Client Benchmarks for {reportData.portfolio.name}</td>
                </tr>
                {/* {reportData.benchmarks.filter(e => e.name === 'clientSpecified').map(benchmark => { return getBenchmarkRow(benchmark) })} */}
                {reportData.benchmarks.sort(benchmarkSorter).filter(e => (e.selected || (e.name === 'clientSpecified' || e.name === 'equalWeight'))).map(benchmark => { return getBenchmarkRow(benchmark, currencyType) })}
            </tbody>
        </table>
    </div>
};

export default Table;


// WEBPACK FOOTER //
// ./src/portfolio/components/ReportTables/ComparativeReturnTable2.js